export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://img.magnific.com/foto-gratis/abstracto-borroso-centro-comercial_1203-8821.jpg?semt=ais_hybrid&w=1024&q=80)',
        }}
      />
      {/* Soft overlay for readability */}
      <div className="absolute inset-0 bg-gradient-radial from-md-sky/80 via-md-light/70 to-white/90" />
      <div className="relative mx-auto flex max-w-[1280px] flex-col gap-12 px-6 py-20 md:flex-row md:items-center md:px-12 md:py-[120px]">
        {/* Left Column */}
        <div className="flex-1">
          {/* Eyebrow */}
          <div className="mb-5 inline-flex items-center gap-2.5 rounded-full border border-md-teal/30 px-4 py-2 bg-white/80 backdrop-blur-sm">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-md-teal opacity-75" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-md-teal" />
            </span>
            <span className="text-[14px] font-semibold text-md-tealDark">
              Pereira · Dosquebradas
            </span>
          </div>

          {/* H1 */}
          <h1 className="mb-6 font-serif text-[36px] font-bold leading-[1.1] text-md-ink md:text-[56px] [text-shadow:2px_2px_4px_rgb(255,255,255)]">
            Tu droguería{' '}
            <span className="text-md-blue">a domicilio</span>{' '}
            en Pereira y Dosquebradas
          </h1>

          {/* Subtitle */}
          <p className="mb-10 max-w-[520px] text-[17px] leading-[1.5] text-md-slate [text-shadow:2px_2px_4px_rgb(255,255,255)]">
            Llámanos o escríbenos por WhatsApp. Confirmamos tu pedido y lo recibes en tu puerta.
          </p>

          {/* CTA Buttons */}
          <div className="mb-8 flex flex-col gap-4 sm:flex-row">
            <a
              href="tel:+573206789030"
              className="group relative flex items-center justify-center gap-3 overflow-hidden rounded-xl bg-md-dark py-4 text-[16px] font-semibold text-white transition-all hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 sm:w-[240px]"
              onClick={() => {
                if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                  ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
                }
              }}
            >
              <span className="absolute inset-0 rounded-xl bg-md-blue/20 opacity-0 transition-opacity group-hover:opacity-100" />
              <span className="absolute -inset-1 rounded-xl bg-md-blue/30 blur-xl animate-pulse-halo" />
              <span className="relative flex h-5 w-5 items-center justify-center">
                <i className="ri-phone-line" />
              </span>
              <span className="relative whitespace-nowrap">Llámanos: 320 678 9030</span>
            </a>
            <a
              href="https://wa.me/573206789030?text=Hola,%20quiero%20pedir%20un%20domicilio"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 rounded-xl bg-md-teal py-4 text-[16px] font-semibold text-white transition-all hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 sm:w-[240px]"
              onClick={() => {
                if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdWaClick) {
                  ((window as unknown as Record<string, unknown>).mdWaClick as () => void)();
                }
              }}
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-whatsapp-line" />
              </span>
              <span className="whitespace-nowrap">WhatsApp</span>
            </a>
          </div>

          {/* Trust Row */}
          <div className="flex flex-wrap items-center gap-3 text-[15px] text-md-slate [text-shadow:2px_2px_4px_rgb(255,255,255)]">
            <span className="flex items-center gap-1.5">
              <span className="flex h-[18px] w-[18px] items-center justify-center text-md-teal">
                <i className="ri-check-line" />
              </span>
              Atención  calida y rapida
            </span>
            <span className="text-md-sky">·</span>
            <span className="flex items-center gap-1.5">
              <span className="flex h-[18px] w-[18px] items-center justify-center text-md-teal">
                <i className="ri-check-line" />
              </span>
              Pereira y Dosquebradas
            </span>
            <span className="text-md-sky">·</span>
            <span className="flex items-center gap-1.5">
              <span className="flex h-[18px] w-[18px] items-center justify-center text-md-teal">
                <i className="ri-check-line" />
              </span>
              Servicio rápido
            </span>
          </div>
        </div>

        {/* Right Column - Card */}
        <div className="flex flex-1 justify-center md:justify-end">
          <div className="w-full max-w-[380px] rounded-[20px] bg-white p-8 shadow-[0_4px_16px_rgba(15,31,53,0.12)]">
            {/* Status */}
            <div className="mb-2 flex items-center gap-2.5">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-md-teal opacity-60" style={{ animationDelay: '0s' }} />
                <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-md-teal opacity-40" style={{ animationDelay: '1s' }} />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-md-teal" />
              </span>
              <span className="text-[15px] font-semibold text-md-tealDark">
                Estamos atendiendo
              </span>
            </div>
            <p className="mb-6 text-[14px] text-md-slate">
              Lun–Vie: 8am–12pm, 2pm–5pm
            </p>

            <div className="mb-6 h-px bg-md-sky" />

            {/* Steps */}
            <h3 className="mb-5 font-serif text-[20px] font-semibold text-md-ink">
              Cómo funciona
            </h3>
            <div className="flex flex-col gap-5">
              {[
                { num: '1', text: 'Llamas o escribes por WhatsApp' },
                { num: '2', text: 'Confirmamos tu pedido contigo' },
                { num: '3', text: 'Recibes en la puerta de tu casa' },
              ].map((step) => (
                <div key={step.num} className="flex items-start gap-4">
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-md-sky font-serif text-[18px] font-bold text-md-blue">
                    {step.num}
                  </span>
                  <span className="pt-1.5 text-[15px] text-md-slate">{step.text}</span>
                </div>
              ))}
            </div>

            <div className="mt-6 flex justify-center">
              <span className="inline-flex items-center gap-2 rounded-full bg-md-sky px-4 py-2 text-[13px] font-medium text-md-dark">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-map-pin-line" />
                </span>
                Pereira y Dosquebradas
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}